import API_ENDPOINTS from '../../constants/api-endpoints'
import urlBuilder from '../url-builder'

/*
    USAGE:
    apiUrlGenerator.userFacilitatorRatings({ userId }, { limit, offset, searchString })
*/

const reducer = (accumulator, endpointKey) => {
    return {
        ...accumulator,
        [endpointKey]: (...args) => urlBuilder(API_ENDPOINTS[endpointKey], ...args)
    }
}

const apiUrlGenerator = Object.keys(API_ENDPOINTS).reduce(reducer, {})

export default apiUrlGenerator